import { computed } from 'vue';
import { useCreditsStore } from '@/stores/credits';
import { useTeamStore } from '@/stores/team';

export function useIdentityCredits() {
  const creditsStore = useCreditsStore();
  const teamStore = useTeamStore();

  const displayBalance = computed(() => (
    teamStore.isTeamMode ? teamStore.teamPoints : creditsStore.balance
  ));

  const displayLoading = computed(() => (
    teamStore.isTeamMode
      ? teamStore.loading && !teamStore.initialized
      : creditsStore.loading && !creditsStore.isInitialized
  ));

  const isDisplayBalanceReady = computed(() => displayBalance.value >= 0);

  async function refreshIdentityCredits() {
    await Promise.allSettled([
      creditsStore.refreshBalance(),
      teamStore.fetchTeamInfo(),
    ]);
  }

  return {
    creditsStore,
    teamStore,
    displayBalance,
    displayLoading,
    isDisplayBalanceReady,
    refreshIdentityCredits,
  };
}
